import { render, staticRenderFns } from "./JMapDemo.vue?vue&type=template&id=12f4f6e4"
import script from "./JMapDemo.vue?vue&type=script&lang=js"
export * from "./JMapDemo.vue?vue&type=script&lang=js"
import style0 from "./JMapDemo.vue?vue&type=style&index=0&id=12f4f6e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports